import { ErrorPayLoad, callQueueReportRequestPayload, callQueueReportSuccessPayload, callReportRequestPayload, callReportSuccessPayload, getUrlRequestPayload, getUrlSuccessPayload } from "../interface/callReport"
import { Types, types } from "../types"
import { callQueueReportError, callQueueReportRequest, callQueueReportSuccess, callReportError, callReportNameError, callReportNameRequest, callReportNameSuccess, callReportRequest, callReportSuccess, getUrlError, getUrlRequest, getUrlSuccess, resetCallReport } from "../types/callReport/actionTypes"




export const callReportRequestAction = (payload: callReportRequestPayload): callReportRequest => ({
    type: Types.GET_CALL_REPORT_REQUEST,
    payload
})

export const callReportSuccessAction = (payload: callReportSuccessPayload): callReportSuccess => ({
    type: Types.GET_CALL_REPORT_SUCCESS,
    payload
})

export const callReportErrorAction = (payload: ErrorPayLoad): callReportError => ({
    type: Types.GET_CALL_REPORT_ERROR,
    payload
})

export const resetCallReportAction = (): resetCallReport => ({
    type: Types.RESET_GET_CALL_REPORT
    
})


//queueReport
export const callQueueReportRequestAction = (payload: callQueueReportRequestPayload): callQueueReportRequest => ({
    type: Types.GET_CALL_QUEUE_REPORT_REQUEST,
    payload
})

export const callQueueReportSuccessAction = (payload: callQueueReportSuccessPayload): callQueueReportSuccess => ({
    type: Types.GET_CALL_QUEUE_REPORT_SUCCESS,
    payload
})

export const callQueueReportErrorAction = (payload: ErrorPayLoad): callQueueReportError => ({
    type: Types.GET_CALL_QUEUE_REPORT_ERROR,
    payload
})

//getUrl
export const getUrlRequestAction = (payload: getUrlRequestPayload): getUrlRequest => ({
    type: Types.GET_RECORD_URL_LIST_REQUEST,
    payload
})

export const getUrlSuccessAction = (payload: getUrlSuccessPayload): getUrlSuccess => ({
    type: Types.GET_RECORD_URL_LIST_SUCCESS,
    payload
})

export const getUrlErrorAction = (payload: ErrorPayLoad): getUrlError => ({
    type: Types.GET_RECORD_URL_LIST_ERROR,
    payload
})
//getName.
export const callReportNameRequestAction = (payload: callReportRequestPayload): callReportNameRequest => ({
    type: Types.GET_CALL_REPORT_NAME_REQUEST,
    payload
})

export const callReportNameSuccessAction = (payload: callReportSuccessPayload): callReportNameSuccess => ({
    type: Types.GET_CALL_REPORT_NAME_SUCCESS,
    payload
})

export const callReportNameErrorAction = (payload: ErrorPayLoad): callReportNameError => ({
    type: Types.GET_CALL_REPORT_NAME_ERROR,
    payload
})


